import Phaser from "phaser";

import {
  BUILDING_FOOTPRINT_TILES,
  BUILDING_VISUAL_HEIGHT_FRAC,
  BUILDING_VISUAL_SCALE,
  BUILDING_VISUAL_WIDTH_FRAC,
  TILE_SIZE,
} from "@cold-case/shared/constants";

/** Visual size ≈ one footprint wide — scaled for readable façades next to NPCs. */
export const BUILDING_VISUAL_W_PX = Math.round(
  TILE_SIZE * BUILDING_FOOTPRINT_TILES * BUILDING_VISUAL_WIDTH_FRAC * BUILDING_VISUAL_SCALE
);
export const BUILDING_VISUAL_H_PX = Math.round(
  TILE_SIZE * BUILDING_FOOTPRINT_TILES * BUILDING_VISUAL_HEIGHT_FRAC * BUILDING_VISUAL_SCALE
);

export type BuildingArtTint = "none" | "placeholder" | "crime_scene";

/** Lock origin + display size for outdoor building façades. */
export function applyBuildingArtSpriteLayout(spr: Phaser.GameObjects.Sprite): void {
  spr.setOrigin(0.5, 0.9);
  spr.setDisplaySize(BUILDING_VISUAL_W_PX, BUILDING_VISUAL_H_PX);
}

function applyBuildingArtTint(spr: Phaser.GameObjects.Sprite, tint: BuildingArtTint): void {
  if (tint === "placeholder") spr.setTint(0xccbbaa);
  else if (tint === "crime_scene") spr.setTint(0xaa6666);
  else spr.clearTint();
}

/** Apply building art and re-lock layout (Phaser resets size on setTexture). */
export function setBuildingArtTexture(
  spr: Phaser.GameObjects.Sprite,
  textureKey: string,
  tint: BuildingArtTint = "none"
): void {
  spr.setTexture(textureKey);
  applyBuildingArtSpriteLayout(spr);
  applyBuildingArtTint(spr, tint);
}
